import { Box } from '@mui/material';
import { ArtworkList } from './ArtworkList';
import { CustomArtwork } from './CustomArtwork';

import { useSelector } from 'react-redux';
import ArtworkControlButtons from './ArtworkControlButtons';
import layout from '../../styles/layout.module.css';
import typography from '../../styles/typography.module.css';
import { useTranslation } from 'react-i18next';
import { isDisabled } from '../../utils/isDisabled';

export const ArtworkController = ({ width, onFlip, onMirror, onReset, onCenter }) => {
    const env = process.env;
    const faceplate = useSelector((state) => state.rootReducer.currentFaceplateOption);
    const currentSide = useSelector((state) => state.rootReducer.settingsOptions.currentSide);
    const currency = useSelector((state) => state.shopifyReducer.ciems[0].currency);
    const { t } = useTranslation();

    const artworkPrice = parseInt(env.REACT_APP_ARTWORK_PRICE);
    const tax = artworkPrice * parseFloat(process.env.REACT_APP_TAX_RATE);
    const price = parseFloat(artworkPrice + tax).toFixed(2);

    return (
        <Box className={`${layout.excerptContainer} ${isDisabled() ? 'is-disabled' : ''}`}>
            <ArtworkList />
            {!isDisabled(currentSide, faceplate) ? (
                <Box className={layout.subSectionContainer}>
                    <h4 className={typography.headerTitle}>
                        {price !== 0 &&
                            `Custom Artwork ${
                                parseInt(price) !== 0
                                    ? `+${currency}${price} ${t('artwork.per_side')}`
                                    : ''
                            }`}
                    </h4>
                    <ArtworkControlButtons
                        onReset={onReset}
                        onMirror={onMirror}
                        onFlip={onFlip}
                        onCenter={onCenter}
                    />
                    <CustomArtwork width={width} isDisable={!isDisabled(currentSide, faceplate)} />
                </Box>
            ) : (
                <Box className={layout.subSectionContainer}>
                    <h4 className={typography.headerTitle}>
                        {price !== 0 && `Custom Artwork is not available for this option`}
                    </h4>
                </Box>
            )}
        </Box>
    );
};
